// extracted by mini-css-extract-plugin
var _1 = "MD_coloredTextButton__+hVl6";
export { _1 as "coloredTextButton" }
